<template>
    <div class="ui-facebook-form-card">
        <div v-if="data.name" class="ui-facebook-form-card-title">
            <div :style="backgroundColor" class="circle" />
            <span :title="data.name" class="text">{{ data.id }} - {{ data.name }}</span>
        </div>

        <ui-button :design="`sm mw-100 ${statusColorComputed}`" @click="action">
            <i class="fal fa-cog" /> {{ statusComputed }}
        </ui-button>
    </div> 
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"

    export default {
        components: {
            uiButton,
        },

        props: {
            data: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
        },

        computed: {
            statusComputed() {
                return this.data.status_gs === 'active' ? 'Integrado' : 'Integrar'
            },

            statusColorComputed() {
                return this.data.status_gs === 'active' ? 'line-success default' : 'line'
            },

            backgroundColor(){
                return `backgroundColor: ${this.data.status == 'ACTIVE' ? '#5AC387' : '#FF5975'}`
            }
        },

        methods: {
            action() {
                if (this.statusComputed == 'Integrar') this.$emit('selected-form', this.data)
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>